import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { GlobalContext } from '../../Context/GlobalContext';
import useAxios from '../../Hooks/useAxios';
import SubprocessForm, {getTargetEmployeeALPSCode, getEmployeeId} from '../SubprocessForm/SubprocessForm';
import MenuListTasks from '../MenuListTasks/MenuListTasks';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, Typography } from '@mui/material';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { MANAGER_DEPARTMENT, STATUS_RESOLVED } from '../../Constants/Global';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from 'react-oidc-context';

import { AxiosService } from '../../Services/AxiosService';
//import AltaCentroForm, {getPositionSpecific, getEmployeeId} from '../AltaCentroForm/AltaCentroForm';

/**
 * A reusable Paper component for the draggable dialog. This component is used to wrap the dialog content
 * and enable dragging functionality.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {React.RefObject} props.nodeRef - A ref to the Paper component.
 * @returns {JSX.Element} A draggable Paper component.
 */
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper 
        {...props} 
        ref={nodeRef} 
        className="formPaper" 
        sx={{
          overflow: "auto",
          position: "fixed",
          top: "90px",
          maxWidth: "460px",
          // minWidth: "360px",
          borderRadius: "30px"
        }}/>
    </Draggable>
  );
}

/**
 * A popup dialog component for displaying and managing subprocess details. It includes a form for viewing
 * subprocess information and a button for resolving the subprocess if the user has the necessary permissions.
 * 
 * @component
 * @returns {JSX.Element} The rendered subprocess popup dialog component.
 */
function SubprocessPopup() {
  const {
    modalOpen,
    setModalOpen,
    modalData,
    setAlertOpen,
    setAlertType,
    setAlertTitle,
    setAlertMessage,
    userProperties,
    setAlertBarSeverity,
    setAlertBarMessage,
    setAlertBarOpen
  } = React.useContext(GlobalContext);
  const { data, isLoading, error } = useAxios("subprocessDetail", modalData.id);

  const [loadingRequest, setLoadingRequest] = React.useState(false);
  const auth = useAuth();

  /**
   * Determines whether the "Resolve" button should be displayed based on the user's permissions and the subprocess status.
   */
  const showResolveButton = !isLoading && !error && data.statusId !== STATUS_RESOLVED && 
    (data.departmentId === userProperties.departmentId || data.responsibleId === userProperties.id); // || userProperties.departmentId === MANAGER_DEPARTMENT)

  /**
   * Handles closing the dialog when the user clicks outside, presses the Escape key,
   * or interacts with specific elements.
   * 
   * @param {Event} event - The event triggering the close action.
   */

   const handleClose = () => {
     setModalOpen(false);
   };

  //const handleClose = (event) => {
  //  if (event.nativeEvent.code === "Escape"
  //    || (event.target.tagName !== "H2"
  //      && event.target.tagName !== "LI"
  //      && event.target.tagName !== "DIV")){
  //    setModalOpen(false);
  //  }
  //};

  /**
   * Handles the "Resolve" button click. Displays a confirmation dialog for resolving the subprocess.
   */
  const handleAccept = () => {
    setAlertType("resolve_subtask");
    setAlertTitle(<Typography color='success'><DoneOutlineIcon color="success" sx={{ fontWeight:'fontWeightBold', position: "relative", top: "5px", marginRight: "10px" }} />Resolve task</Typography>);
    setAlertMessage(<Typography>Are you sure you want to solve the task?<br/>This action cannot be undone</Typography>);
    // setModalOpen(false);
    setAlertOpen(true);
  };
  
  // Generate the dialog title based on the subprocess data or loading/error state
  let popupTitle = "";

  if (!isLoading){
    if (error) {
      setAlertBarSeverity("error");
      setAlertBarMessage(error);
      setAlertBarOpen(true);
      popupTitle = error;
    } else {
      popupTitle = <MenuListTasks item={{...data, type: "subprocess"}} tagType="forms" key={"subprocess" + data.id} />;
    }
  } else {
    popupTitle = <><CircularProgress size="1rem" sx={{marginRight: "4px"}} />Loading...</>;
  }


  /**
       * Handles the "Save" button click. Saves the updated end date for the process via an API call.
       */
      const handleSave = () => {

          console.log("--------------getTargetEmployeeALPSCode: ", getTargetEmployeeALPSCode());
          console.log("--------------getEmployeeId: ", getEmployeeId());


          setLoadingRequest(true);
          //const requestBody =  {
          //  endDate: NewProcessEndDate
          //};
          //console.log(modalData)
          //console.log("modalData : ", modalData)
          //console.log("requestBody : ", requestBody)



          const requestBody0 =  {

              targetEmployee: {

                  alpsCode: getTargetEmployeeALPSCode()
                  }

              }
               console.log("requestBody: ", requestBody0);

          AxiosService.patch_alps_code(auth.user?.access_token, requestBody0, getEmployeeId())
          .then((response) => {
            //console.log("response: ", response);
            //setLoadingPOST(false);
            setAlertBarSeverity("success");
            setAlertBarMessage(response.data.message);
            setAlertBarOpen(true);
            //setNewTaskOpen(false);
            //navigate("/#");
          })

          .catch((err) => {
            setAlertBarSeverity("error");
            setAlertBarMessage(`${err.message} (${err.response.statusText}): ${err.response.data.error}`);
            setAlertBarOpen(true);
          })
          .finally(() => {
            setLoadingRequest(false);
          });
      }




  return (
    <> 
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'unset' }} id="draggable-dialog-title" onClick={handleClose}>
        {popupTitle}
      </DialogTitle>
      {!isLoading && !error &&
      <DialogContent sx={{maxHeight: "62vh"}}>
          <SubprocessForm subProcessData={data}></SubprocessForm>
      </DialogContent>}
      {!isLoading &&
      <DialogActions> 
        <Button sx={{  fontWeight:'fontWeightBold' }} onClick={handleClose}>
          <CloseIcon/> Exit
        </Button>
        {showResolveButton && <Button color="success" sx={{ fontWeight:'fontWeightBold' }} onClick={handleAccept}>
          <DoneIcon /> Resolve
        </Button>}

         <Button color="primary" sx={{ fontWeight:'fontWeightBold', margin: "auto" }} onClick={handleSave} loading={loadingRequest}>
           <SaveIcon /> Save
         </Button>
         {/*<ProcessDetails/>*/}

      </DialogActions>
      }
    </Dialog>
  </>
  );
}

export default SubprocessPopup;
